import React from 'react';
import { presetPalettes } from '@ant-design/colors';
import type { ColorPickerProps } from 'antd';
import { Col, ColorPicker, Divider, Row, theme } from 'antd';

type Presets = Required<ColorPickerProps>['presets'][number];



// Grouped by hue family (red -> orange -> yellow -> green -> teal -> blue -> purple -> pink -> brown/neutral)
// so visually related colors sit next to each other in the picker.
export const LEAD_STATUS_COLORS = [
  "#9B2335",  // Burgundy
  "#BC243C",  // Crimson
  "#E63946",  // Fire Red
  "#DD4124",  // Red Orange
  "#FF6F61",  // Coral
  "#E15D44",  // Burnt Orange
  "#F4A261",  // Sandy Orange
  "#EFC050",  // Warm Yellow
  "#FFD166",  // Sunflower Yellow
  "#88B04B",  // Soft Green
  "#06D6A0",  // Emerald Green
  "#CAFFBF",  // Pale Green
  "#009B77",  // Dark Teal
  "#2A9D8F",  // Teal
  "#45B8AC",  // Mint
  "#55B4B0",  // Turquoise
  "#7FCDCD",  // Aquamarine
  "#118AB2",  // Ocean Blue
  "#92A8D1",  // Cool Blue
  "#3A86FF",  // Azure Blue
  "#BDB2FF",  // Periwinkle
  "#5B5EA6",  // Indigo
  "#6B5B95",  // Deep Purple
  "#8338EC",  // Bright Violet
  "#B565A7",  // Plum
  "#C77DFF",  // Bright Lilac
  "#D65076",  // Orchid
  "#D94F70",  // Raspberry
  "#FF70A6",  // Hot Pink
  "#F7CAC9",  // Light Pink
  "#FFADAD",  // Blush Pink
  "#955251",  // Mauve
  "#D4A373",  // Camel Brown
  "#6C4F3D",  // Coffee Brown
  "#8D99AE"   // Slate Gray
];
function genPresets(presets = presetPalettes) {
  return Object.entries(presets).map<Presets>(([label, colors]) => ({ label, colors, key: label }));
}


export default function ColorPickerWithPresets({value, onChange}) {
  const { token } = theme.useToken();

  const customPanelRender: ColorPickerProps['panelRender'] = (
    _,
    { components: { Picker, Presets } },
  ) => (
    <Row justify="space-between" wrap={false}>
      <Col span={12}>
        <Presets />
      </Col>
      <Divider type="vertical" style={{ height: 'auto' }} />
      <Col flex="auto">
        <Picker />
      </Col>
    </Row>
  );

  return (
    <ColorPicker
      format={"hex"}
      size={"small"}
      defaultFormat={"hex"}
      value={value}
      onChangeComplete={color => onChange(`#${color.toHex()}`)}
      defaultValue={token.colorPrimary}
      styles={{ popupOverlayInner: { width: 480 } }}
      disabledAlpha
      disabledFormat
      presets={[{
        defaultOpen: true,
        colors:LEAD_STATUS_COLORS
      }]}
      panelRender={customPanelRender}
    />
  );
};
